import { render, staticRenderFns } from "./shiftManagementAssistant.vue?vue&type=template&id=64cd010c&scoped=true"
import script from "./shiftManagementAssistant.vue?vue&type=script&lang=js"
export * from "./shiftManagementAssistant.vue?vue&type=script&lang=js"
import style0 from "./shiftManagementAssistant.vue?vue&type=style&index=0&id=64cd010c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd010c",
  null
  
)

export default component.exports